
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Flex,
//   Avatar,
//   Text,
//   Button,
//   Spinner,
//   IconButton,
//   VStack,
// } from "@chakra-ui/react";
// import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
// import { useDispatch, useSelector } from "react-redux";
// import { getExpertDetailProfile } from "../../../actions/user/userActions";
// import { Link } from "react-router-dom";

// const Recommendations = () => {
//   const dispatch = useDispatch();
//   const [activeView, setActiveView] = useState("experts"); // default to expert view
//   const [currentExpertIndex, setCurrentExpertIndex] = useState(0);

//   const { data: rawData, loading } = useSelector(
//     (state) => state.expertDetailProfileReducer || {}
//   );

//   useEffect(() => {
//     dispatch(getExpertDetailProfile());
//   }, [dispatch]);

//   const experts = Array.isArray(rawData) ? rawData : [];

//   const toggleView = () => {
//     setActiveView((prev) => (prev === "experts" ? "whatToDo" : "experts"));
//   };

//   const handlePrev = () => {
//     setCurrentExpertIndex((prev) => Math.max(prev - 1, 0));
//   };

//   const handleNext = () => {
//     setCurrentExpertIndex((prev) =>
//       Math.min(prev + 1, experts.length - 1)
//     );
//   };

//   if (loading) {
//     return (
//       <Flex justify="center" align="center" h="50vh">
//         <Spinner size="lg" />
//       </Flex>
//     );
//   }

//   return (
//     <Box px={6} py={4} bg="white" borderRadius="md" boxShadow="sm">
//       {/* === Header Section === */}
//       <Flex justify="space-between" align="center" mb={4}>
//         <Text fontSize="sm" fontWeight="medium">
//           When EBITDA% is{" "}
//           <Text as="span" color="green.600" fontWeight="bold">
//             Very High - Rising
//           </Text>
//         </Text>

//         <Button
//           onClick={toggleView}
//           variant="ghost"
//           size="sm"
//           fontSize="xs"
//           fontWeight="medium"
//           color="gray.600"
//         >
//           {activeView === "experts"
//             ? "🛈 What to do next?"
//             : "Get an expert’s help"}
//         </Button>
//       </Flex>

//       {/* === View: What to do next === */}
//       {activeView === "whatToDo" && (
//         <Flex gap={4} wrap="wrap" justify="space-between">
//           <Box
//             flex="1"
//             minW="220px"
//             bg="white"
//             border="1px solid #ccc"
//             borderRadius="md"
//             p={4}
//           >
//             <Text
//               fontWeight="bold"
//               fontSize="sm"
//               bg="#5B5B5B"
//               color="white"
//               px={3}
//               py={1}
//               borderRadius="sm"
//               mb={2}
//               display="inline-block"
//             >
//               WAYS TO ASSESS OR DIAGNOSE
//             </Text>
//             <Text fontSize="sm">
//               Monitor market dynamics and adjust pricing strategies accordingly
//             </Text>
//           </Box>

//           <Box
//             flex="1"
//             minW="220px"
//             bg="white"
//             border="1px solid #ccc"
//             borderRadius="md"
//             p={4}
//           >
//             <Text
//               fontWeight="bold"
//               fontSize="sm"
//               bg="#5B5B5B"
//               color="white"
//               px={3}
//               py={1}
//               borderRadius="sm"
//               mb={2}
//               display="inline-block"
//             >
//               INTERNAL CONTROLS
//             </Text>
//             <Text fontSize="sm" mb={1}>
//               Maintain competitive edge
//             </Text>
//             <Text fontSize="sm">
//               Develop cost control and operational efficiency, research and
//               development to drive innovation
//             </Text>
//           </Box>
//         </Flex>
//       )}

//       {/* === View: Recommended Experts === */}
//       {activeView === "experts" && experts.length > 0 && (
//         <>
//           <Text fontWeight="bold" fontSize="md" mt={2} mb={1}>
//             RECOMMENDED EXPERTS
//           </Text>
//           <Text fontSize="xs" color="gray.600" mb={4}>
//             Because your EBITDA % is lower than peers
//           </Text>

//           <Flex
//   gap={4}
//   align="center"
//   justify="center"
//   bg="#F8F8F8"
//   p={4}
//   borderRadius="md"
// >
//   <IconButton
//     icon={<ChevronLeftIcon color="#5D5D5D" />}
//     aria-label="Previous"
//     size="sm"
//     variant="ghost"
//     onClick={handlePrev}
//     isDisabled={currentExpertIndex === 0}
//   />

//   <Box
//     key={experts[currentExpertIndex]._id}
//     maxW="300px"
//     p={4}
//     borderWidth="1px"
//     borderRadius="md"
//     bg="white"
//     boxShadow="sm"
//   >
//     <Flex align="flex-start" gap={4}>
//       {/* Avatar on the left */}
//       <Avatar
//         name={experts[currentExpertIndex].expert_name}
//         src={experts[currentExpertIndex].profile_image}
//         size="md"
//       />

//       {/* Info and button on the right */}
//       <Flex direction="column" flex="1">
//         <Flex justify="flex-end" mb={2}>
//           <Link to={`/user/expert-profile/${experts[currentExpertIndex]._id}`}>
//             <Button
//               bg="gray.100"
//               color="#5D5D5D"
//               border="1px solid #aaa"
//               size="sm"
//               _hover={{ bg: "gray.200" }}
//             >
//               View Complete Profile
//             </Button>
//           </Link>
//         </Flex>

//         <Text fontWeight="bold" fontSize="sm" noOfLines={2}>
//           {experts[currentExpertIndex].expert_name}
//         </Text>
//         <Text fontSize="xs" color="gray.600" noOfLines={2} mb={2}>
//           {experts[currentExpertIndex].expert_title}
//         </Text>
//       </Flex>
//     </Flex>
//   </Box>

//   <IconButton
//     icon={<ChevronRightIcon color="#5D5D5D" />}
//     aria-label="Next"
//     size="sm"
//     variant="ghost"
//     onClick={handleNext}
//     isDisabled={currentExpertIndex === experts.length - 1}
//   />
// </Flex>


//           <Flex justify="center" mt={5}>
//             <Button bg="#333" color="white" size="sm" _hover={{ bg: "#222" }}>
//               Book Discovery Call
//             </Button>
//           </Flex>
//         </>
//       )}
//     </Box>
//   );
// };

// export default Recommendations;



import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Avatar,
  Text,
  Button,
  Spinner,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { getExpertDetailProfile } from "../../../actions/user/userActions";
import { Link } from "react-router-dom";

const Recommendations = () => {
  const dispatch = useDispatch();
  const [activeView, setActiveView] = useState("experts"); // default to expert view
  const [currentExpertIndex, setCurrentExpertIndex] = useState(0);

  const { data: rawData, loading } = useSelector(
    (state) => state.expertDetailProfileReducer || {}
  );

  useEffect(() => {
    dispatch(getExpertDetailProfile());
  }, [dispatch]);

  const experts = Array.isArray(rawData) ? rawData : [];

  const toggleView = () => {
    setActiveView((prev) => (prev === "experts" ? "whatToDo" : "experts"));
  };

  const handlePrev = () => {
    setCurrentExpertIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentExpertIndex((prev) =>
      Math.min(prev + 1, experts.length - 1)
    );
  };

  if (loading) {
    return (
      <Flex justify="center" align="center" h="50vh">
        <Spinner size="lg" />
      </Flex>
    );
  }

  return (
    <Box px={6} py={4} bg="white" borderRadius="md" boxShadow="sm"  overflowX="hidden" >
      {/* === Header Section === */}
      <Flex justify="space-between" align="center" mb={4}>
        <Text fontSize="sm" fontWeight="medium">
          When EBITDA% is{" "}
          <Text as="span" color="green.600" fontWeight="bold">
            Very High - Rising
          </Text>
        </Text>

        <Button
          onClick={toggleView}
          variant="gray.100"
          size="sm"
          fontSize="xs"
          fontWeight="medium"
          color="gray.600"
        >
          {activeView === "experts"
            ? "🛈 What to do next?"
            : "Get an expert’s help"}
        </Button>
      </Flex>

      {/* === View: What to do next === */}
      {activeView === "whatToDo" && (
        <Flex gap={4} wrap="wrap" justify="space-between">
          <Box
            flex="1"
            minW="220px"
            bg="white"
            border="1px solid #ccc"
            borderRadius="md"
            p={4}
          >
            <Text
              fontWeight="bold"
              fontSize="sm"
              bg="#5B5B5B"
              color="white"
              px={3}
              py={1}
              borderRadius="sm"
              mb={2}
              display="inline-block"
            >
              WAYS TO ASSESS OR DIAGNOSE
            </Text>
            <Text fontSize="sm">
              Monitor market dynamics and adjust pricing strategies accordingly
            </Text>
          </Box>

          <Box
            flex="1"
            minW="220px"
            bg="white"
            border="1px solid #ccc"
            borderRadius="md"
            p={4}
          >
            <Text
              fontWeight="bold"
              fontSize="sm"
              bg="#5B5B5B"
              color="white"
              px={3}
              py={1}
              borderRadius="sm"
              mb={2}
              display="inline-block"
            >
              INTERNAL CONTROLS
            </Text>
            <Text fontSize="sm" mb={1}>
              Maintain competitive edge
            </Text>
            <Text fontSize="sm">
              Develop cost control and operational efficiency, research and
              development to drive innovation
            </Text>
          </Box>
        </Flex>
      )}

      {/* === View: Recommended Experts === */}
      {activeView === "experts" && experts.length > 0 && (
        <>
          <Text fontWeight="bold" fontSize="md" mt={2} mb={1}>
            RECOMMENDED EXPERTS
          </Text>
          <Text fontSize="xs" color="gray.600" mb={4}>
            Because your EBITDA % is lower than peers
          </Text>

          <Flex
            gap={1}
            align="center"
            justify="center"
            bg="#F8F8F8"
            p={4}
            borderRadius="md"
          >
            <IconButton
              icon={<ChevronLeftIcon color="#5D5D5D" />}
              aria-label="Previous"
              size="sm"
              variant="#E6E6E6"
              onClick={handlePrev}
              isDisabled={currentExpertIndex === 0}
            />

            <Box
              key={experts[currentExpertIndex]._id}
              maxW="300px"
              p={4}
              borderWidth="1px"
              borderRadius="md"
              bg="white"
              boxShadow="sm"
            >
              <Flex align="flex-start" gap={4}>
                {/* Avatar on the left */}
                <Avatar
                  name={experts[currentExpertIndex].expert_name}
                  src={experts[currentExpertIndex].profile_image}
                  size="md"
                />

                {/* Info and button on the right */}
                <Flex direction="column" flex="1">
                  <Flex justify="flex-end" mb={2}>
                    <Link to={`/user/expert-profile/${experts[currentExpertIndex]._id}`}>
                      <Button
                        bg="gray.100"
                        color="#5D5D5D"
                        border="1px solid #aaa"
                        size="sm"
                        _hover={{ bg: "white" }}
                      >
                        View Complete Profile
                      </Button>
                    </Link>
                  </Flex>

                  <Text fontWeight="bold" fontSize="sm" noOfLines={2}>
                    {experts[currentExpertIndex].expert_name}
                  </Text>
                  <Text fontSize="xs" color="gray.600" noOfLines={2} mb={2}>
                    {experts[currentExpertIndex].expert_title}
                  </Text>
                </Flex>
              </Flex>
            </Box>

            <IconButton
              icon={<ChevronRightIcon color="#5D5D5D"  />}
              aria-label="Next"
              size="sm"
              variant="#E6E6E6"
              onClick={handleNext}
              isDisabled={currentExpertIndex === experts.length - 1}
            />
          </Flex>

          <Flex justify="center" mt={5}>
            <Button bg="#333" color="white" size="sm" _hover={{ bg: "#222" }}>
              Book Discovery Call
            </Button>
          </Flex>
        </>
      )}
    </Box>
  );
};

export default Recommendations;
